import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import BaseComponent from '../../baseClasses/BaseComponent';
import MobileFilter from '../MobileFilter';
import OfflineCloudIcon from '../../assets/images/offline-cloud.svg';
import caret from '../../assets/images/caret-white.svg';
import './MobileHeader.scss';
import HandsFreeButton from '../HandsFreeButton';

export class MobileHeader extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      filterOpen: false,
    };
    MobileHeader.propTypes = {
      /** if true, there will be a 'Done' button in the top left instead of a back arrow */
      useDoneButton: PropTypes.bool,
      /** called when 'Done' or the back arrow is selected. */
      navigateBack: PropTypes.func,
    };
    this.navigateBack = this.navigateBack.bind(this);
  }

  openFilter = () => {
    this.setState({ filterOpen: true });
  }

  closeFilter = () => {
    this.setState({ filterOpen: false });
  }

  navigateBack() {
    const { navigateBack } = this.props; 
    if (navigateBack) {
      navigateBack();
    }
    else this.props.history.goBack();
  }

  render() {
    const { 
      headerTitle, 
      filterOptions, 
      appliedFilters,  
      hasFilters, 
      useDoneButton,
      noBackButton,
      displayHandsFree,
      offlineFilter,
    } = this.props;

    let backArrow;
    let filterIcon;
    let offlineChangesIndicator;
    let isFiltered = false; 
    let handsfree;
    
    if (appliedFilters) {
      isFiltered = Object.keys(appliedFilters).find(filter => appliedFilters[filter].length);
    }

    if (!noBackButton) {
      backArrow = <a className="mobile-header-back" onClick={this.navigateBack}>
          <img className="mobile-header-back-caret" alt="Back Arrow" src={caret} />
        </a>;
    } 
    if (useDoneButton) {
      backArrow = <a className='mobile-header-done' onClick={this.navigateBack}>Done</a>;
    }
    
    if (hasFilters && filterOptions && appliedFilters) {
      filterIcon =
      <a className={`mobile-header__filter-icon ${isFiltered ? 'filtered' : ''}`}
          onClick={this.openFilter}
      />;
    }

    if (this.props.hasOfflineChanges) {
      offlineChangesIndicator = <img src={OfflineCloudIcon} alt="offline-changes-pending" />;
    }

    if (displayHandsFree) {
      handsfree = <HandsFreeButton />;
    }

    return (
      <header className='mobile-header'>
        {backArrow}
        <p className='header-title'>
          {offlineChangesIndicator}
          {headerTitle}
        </p>
        {filterIcon}
        {
          this.state.filterOpen &&
            <MobileFilter
              filterOptions={filterOptions}
              appliedFilters={appliedFilters}
              applyFilters={this.props.applyFilters}
              closeFilter={this.closeFilter}
              handleClear={this.props.handleClear}
              offlineFilter={offlineFilter}
              handleAppliedFilters={this.props.handleAppliedFilters}
            />
        }
        {handsfree}
      </header>
    );
  }
}

export default withRouter(MobileHeader);



// WEBPACK FOOTER //
// ./src/components/MobileHeader/index.js